import React, { useEffect, useState } from "react";
import WaitingforInfo from "./ProgressBarIndicators/WaitingforInfo";
import NeedsApproval from "./ProgressBarIndicators/NeedsApproval";
import ReviewComplete from "./ProgressBarIndicators/ReviewComplete";
import SubmittedforReview from "./ProgressBarIndicators/SubmittedforReview";
import './AppTable.css'
import { useDispatch, useSelector } from "react-redux";
import { GetMissingInfoDetails, orderSummarySelector } from "../../features/ordersSummary/orderSummarySlice";
import FinalReview from "./ProgressBarIndicators/FinalReview";

const PendingOrderProgressBar = ({ missinginfo, progressBarStatus ,fileID}) => {

  return (
    <div>
      <div className="relative element">
        {" "}
        <div
          className="cursor-default flex progress-bar-status"
          ariaLabel="Progress bar status"
        >
          {" "}
          <div className="flex mt-2">
            {" "}
            {progressBarStatus === "Waiting for Information" && <WaitingforInfo fileID={fileID} MissingInfos={missinginfo}/>}
            {progressBarStatus === "Needs Approval" && <NeedsApproval />}
            {progressBarStatus === "Review Complete" && <ReviewComplete />}
            {progressBarStatus === "Under Review" &&  <SubmittedforReview />}
            {progressBarStatus === "Final Review" &&  <FinalReview />}
          </div>{" "}
        </div>{" "}
      </div>
    </div>
  );
};

export default PendingOrderProgressBar;
